class CartDrawerRecommendations {
  constructor() {
    this.container = document.getElementById('CartDrawerRecommendations');
    if (!this.container) return;
    this.lastProductId = null;
    this.init();
  }

  init() {
  
    this.patchFetch();

    const drawer = document.getElementById('MinimogCartDrawer');
    if (drawer) {
      const observer = new MutationObserver(() => this.fetchRecommendations());
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

   
    this.fetchRecommendations();
  }

  patchFetch() {
    const originalFetch = window.fetch;
    const self = this;
    window.fetch = function (...args) {
      const url = args[0]?.toString() || '';
      const result = originalFetch.apply(this, args);
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        result.then(() => setTimeout(() => self.fetchRecommendations(), 300));
      }
      return result;
    };
  }

  async fetchRecommendations() {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    if (!cart.items || cart.items.length === 0) {
      this.container.innerHTML = '';
      this.lastProductId = null;
      return;
    }

    const lastItem = cart.items[cart.items.length - 1];
    const productId = lastItem.product_id;

    if (productId === this.lastProductId && this.container.innerHTML !== '') return;
    this.lastProductId = productId;

    const limit = this.container.dataset.limit || 4;

    try {
      const res = await fetch(
        `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`
      );
      const data = await res.json();

      if (!data.products || data.products.length === 0) {
        this.container.innerHTML = '';
        return;
      }

      this.render(data.products, cart.items);
    } catch (err) {
      console.error('Cart recommendations error:', err);
    }
  }

  render(products, cartItems) {
    const cartVariantIds = cartItems.map((i) => i.variant_id);

    const cards = products
      .filter((p) => !p.variants.every((v) => cartVariantIds.includes(v.id)))
      .map((product) => {
        const variant = product.variants[0];
        const image = product.featured_image || (product.images && product.images[0]);
        const compareAt = variant.compare_at_price;
        const price = variant.price;

        return `
          <div class="m-cart-recommend__item">
            <a href="${product.url}" class="m-cart-recommend__image">
              <img src="${image}" alt="${product.title}" loading="lazy" width="64" height="64">
            </a>
            <div class="m-cart-recommend__info">
              <a href="${product.url}" class="m-cart-recommend__title">${product.title}</a>
              <div class="m-cart-recommend__price">
                ${
                  compareAt && parseFloat(compareAt) > parseFloat(price)
                    ? `<span class="m-cart-recommend__price--sale">${this.formatMoney(price)}</span>
                       <s class="m-cart-recommend__price--compare">${this.formatMoney(compareAt)}</s>`
                    : `<span>${this.formatMoney(price)}</span>`
                }
              </div>
            </div>
     <button type="button" class="m-button m-button--primary m-button--small m-cart-recommend__add" data-variant-id="${variant.id}">+ Add</button>
          </div>
        `;
      })
      .join('');

    if (!cards) {
      this.container.innerHTML = '';
      return;
    }

    this.container.innerHTML = `
      <div class="m-cart-recommend">
        <p class="m-cart-recommend__heading">You May Also Like</p>
        <div class="m-cart-recommend__list">${cards}</div>
      </div>
    `;

    this.container.querySelectorAll('[data-variant-id]').forEach((btn) => {
      btn.addEventListener('click', (e) => this.addToCart(e.currentTarget));
    });
  }

  formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2);
  }

  async addToCart(button) {
    const variantId = button.dataset.variantId;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      const drawer = document.getElementById('MinimogCartDrawer');
      if (drawer && typeof drawer.onCartDrawerUpdate === 'function') {
        drawer.onCartDrawerUpdate();
        if (typeof drawer.open === 'function') {
          drawer.open();
        }
      }

      button.disabled = false;
      button.textContent = originalText;
    } catch (err) {
      console.error('Add to cart error:', err);
      button.disabled = false;
      button.textContent = originalText;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new CartDrawerRecommendations());